export const extractTextFromImage = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("apikey", "helloworld"); // FREE public key (limited usage)

    const res = await fetch("https://api.ocr.space/parse/image", {
      method: "POST",
      body: formData,
    });

    const data = await res.json();

    if (data?.ParsedResults?.length > 0) {
      return data.ParsedResults[0].ParsedText;
    }

    return "";
  } catch (error) {
    console.error("OCR Error:", error);
    return "";
  }
};